var _rect, _pattern, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "url(#pattern0)"
  })), /*#__PURE__*/React.createElement("defs", null, _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#coin",
    transform: "scale(0.0025)"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "coin",
    width: 400,
    height: 400,
    viewBox: "-20 -20 176 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.5,
    cy: 68,
    rx: 67.5,
    ry: 68,
    fill: "url(#paint0_linear_1217_2601)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.5,
    cy: 67,
    rx: 66.5,
    ry: 67,
    fill: "url(#paint1_linear_1217_2601)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.821,
    cy: 67.5,
    rx: 55,
    ry: 55.5,
    fill: "url(#paint2_linear_1217_2601)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 68,
    cy: 67.5,
    rx: 52,
    ry: 52.5,
    fill: "url(#paint3_linear_1217_2601)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8207 70.0012C28.8207 47.357 47.1777 29 69.82 29C76.2052 28.9946 82.5032 30.4831 88.2104 33.3463C93.9177 36.2096 98.876 40.3683 102.689 45.49H91.4187C87.9427 42.4263 83.8548 40.137 79.4264 38.7741C74.9979 37.4111 70.3302 37.0058 65.7331 37.5848C61.136 38.1639 56.7146 39.7141 52.7625 42.1327C48.8103 44.5513 45.4178 47.7828 42.8102 51.6129C40.2025 55.4429 38.4394 59.7837 37.6378 64.3473C36.8361 68.9109 37.0144 73.5928 38.1606 78.0822C39.3069 82.5716 41.395 86.7659 44.2863 90.3866C47.1776 94.0072 50.8059 96.9715 54.9305 99.0826V108.21C39.6487 102.25 28.8207 87.3942 28.8207 70.0012ZM71.5869 70.4725V62.146H110.073C109.519 59.2867 108.658 56.4952 107.507 53.8196H63.2587V110.476C65.4289 110.825 67.6236 111 69.8217 111C70.4138 111 71.0022 110.983 71.5869 110.959V78.8007H109.872C110.47 76.0648 110.786 73.2747 110.815 70.4743L71.5869 70.4725ZM79.9145 100.084V108.755C85.8413 107.244 91.3558 104.428 96.0554 100.514C100.755 96.5997 104.521 91.6852 107.079 86.1294H97.6424C93.5725 92.7339 87.2901 97.6792 79.9145 100.084Z",
    fill: "url(#paint4_linear_1217_2601)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8219 67.0929C24.8219 44.398 43.2199 26 65.9129 26C72.3124 25.9946 78.6244 27.4864 84.3444 30.356C90.0645 33.2257 95.0338 37.3937 98.8554 42.5269H87.5599C84.0761 39.4563 79.9791 37.1619 75.5407 35.7959C71.1024 34.43 66.4242 34.0236 61.8168 34.604C57.2094 35.1844 52.7782 36.7381 48.8172 39.1621C44.8562 41.5861 41.4562 44.8248 38.8427 48.6634C36.2292 52.502 34.4621 56.8526 33.6587 61.4263C32.8553 66.0001 33.0339 70.6925 34.1827 75.1919C35.3316 79.6914 37.4243 83.895 40.3221 87.5238C43.2198 91.1526 46.8563 94.1235 50.9901 96.2393V105.387C35.6742 99.4141 24.8219 84.5247 24.8219 67.0929ZM67.6837 67.5652V59.2202H106.256C105.7 56.3544 104.838 53.5567 103.684 50.8751H59.3368V107.658C61.5119 108.008 63.7115 108.184 65.9145 108.183C66.508 108.183 67.0977 108.167 67.6837 108.142V75.9121H106.054C106.654 73.17 106.971 70.3737 107 67.5671L67.6837 67.5652ZM76.0299 97.2432V105.933C81.9699 104.419 87.4967 101.597 92.2069 97.6738C96.917 93.7507 100.692 88.8252 103.255 83.257H93.7974C89.7184 89.8763 83.422 94.8327 76.0299 97.2432Z",
    fill: "url(#paint5_linear_1217_2601)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.821 68.0149C25.821 45.3637 44.1837 27.001 66.833 27.001C73.2203 26.9956 79.5201 28.4845 85.2292 31.3486C90.9382 34.2128 95.898 38.3728 99.7122 43.4961H88.4385C84.9614 40.4315 80.8722 38.1414 76.4424 36.7781C72.0126 35.4147 67.3434 35.0092 62.7449 35.5884C58.1463 36.1677 53.7236 37.7184 49.7702 40.1378C45.8169 42.5571 42.4233 45.7896 39.8149 49.6208C37.2064 53.452 35.4427 57.7942 34.6409 62.3592C33.839 66.9242 34.0173 71.6076 35.1639 76.0984C36.3105 80.5892 38.3992 84.7847 41.2914 88.4065C44.1836 92.0283 47.8131 94.9935 51.9389 97.1053V106.236C36.6525 100.274 25.821 85.4132 25.821 68.0149ZM68.6003 68.4863V60.1573H107.099C106.544 57.297 105.683 54.5047 104.532 51.8283H60.2695V108.503C62.4404 108.852 64.6357 109.027 66.8346 109.026C67.4268 109.026 68.0154 109.01 68.6003 108.986V76.8171H106.897C107.495 74.0803 107.812 71.2894 107.841 68.4881L68.6003 68.4863ZM76.9305 98.1073V106.781C82.859 105.269 88.3752 102.453 93.0763 98.537C97.7774 94.6214 101.545 89.7054 104.103 84.1479H94.6638C90.5926 90.7545 84.3083 95.7013 76.9305 98.1073Z",
    fill: "url(#paint6_linear_1217_2601)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.8 39.1834C147.168 79.9057 121.72 115.179 101.813 126C119.772 94.2175 106.928 74.6385 98.2607 68.8218C92.2911 66.3682 82.1147 56.3884 89.1661 36.0978C96.2175 15.8073 68.1881 4.87705 53.2919 1.94823C72.9123 -2.99571 111.469 0.759872 128.8 39.1834Z",
    fill: "#4E4E4E",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1217_2601",
    x1: 77.8846,
    y1: 88.9231,
    x2: 15.2465,
    y2: 135.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1217_2601",
    x1: 26.3227,
    y1: 36.4981,
    x2: 303.811,
    y2: 152.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1217_2601",
    x1: 139,
    y1: 118.5,
    x2: 0.891311,
    y2: 24.3933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B3B3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1217_2601",
    x1: 15.6057,
    y1: 34.2254,
    x2: 143.698,
    y2: 127.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1217_2601",
    x1: 218.5,
    y1: 175.5,
    x2: 12.4873,
    y2: 9.51582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E2E2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1217_2601",
    x1: -44.8079,
    y1: 25.0434,
    x2: 162.508,
    y2: 122.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00348658,
    stopColor: "#A19D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E2E2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1217_2601",
    x1: -8,
    y1: 30,
    x2: 108.007,
    y2: 114.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00348658,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0A0A0"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/Coin.323179e52dd4e03f22664438aa3480c5.svg";
export { ForwardRef as ReactComponent };